export default "__VITE_ASSET__94af95f4__"